// src/components/proposals/ProposalStickyRail.tsx
// (This file is correct as provided previously)

import React from 'react';
import { Card, Button, TextField } from '@dopomogai/ui';
import { Download, BookUser } from 'lucide-react';
// We are assuming `LiveQuoteCalculator.tsx` is created and imported here.
// For simplicity, I'll inline its logic for this example.

const formatCurrency = (amount: number) => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0 }).format(amount);

const LiveQuoteCalculator: React.FC<{totalCost: number; partnerPrice: number; totalEta: number;}> = ({ totalCost, partnerPrice, totalEta }) => (
    <Card>
      <div className="p-5">
        <h3 className="text-lg font-extrabold text-slate-900 mb-3">Live Quote</h3>
        <div className="space-y-2 text-sm">
          <div className="flex justify-between items-center">
            <span className="text-slate-600">Total Setup Cost:</span>
            <span className="font-bold text-slate-800">{formatCurrency(totalCost)}</span>
          </div>
          <div className="flex justify-between items-center text-emerald-700 bg-emerald-50 -mx-2 px-2 py-1 rounded">
            <strong>Your Partner Price (11% off):</strong>
            <strong className="text-xl">{formatCurrency(partnerPrice)}</strong>
          </div>
          <hr className="my-2 border-slate-200" />
          <div className="flex justify-between items-center">
            <span className="text-slate-600">Est. Business Days:</span>
            <span className="font-bold text-slate-800">{totalEta}</span>
          </div>
        </div>
      </div>
    </Card>
);


export const ProposalStickyRail: React.FC<{
  quote: { totalCost: number; partnerPrice: number; totalEta: number; };
  clientMarkup: number;
  onMarkupChange: (value: number) => void;
  onDownloadPdf: () => void;
  onBookCall: () => void;
  chatHost: React.ReactNode;
}> = ({ quote, clientMarkup, onMarkupChange, onDownloadPdf, onBookCall, chatHost }) => {
  const clientPrice = quote.partnerPrice * (1 + clientMarkup / 100);
  const yourMargin = clientPrice - quote.partnerPrice;

  return (
    <div className="space-y-4">
      <LiveQuoteCalculator
        totalCost={quote.totalCost}
        partnerPrice={quote.partnerPrice}
        totalEta={quote.totalEta}
      />
      <Card>
        <div className="p-5">
          <h3 className="text-lg font-extrabold text-slate-900 mb-3">Calculate Your Margin</h3>
          <TextField
            label="Your Client Markup %"
            type="number"
            value={String(clientMarkup)}
            onChange={(e) => onMarkupChange(Math.max(0, Number(e.target.value)))}
          />
          <div className="space-y-1 text-sm mt-3">
            <div className="flex justify-between"><span>Your Cost:</span><span className="font-bold">{formatCurrency(quote.partnerPrice)}</span></div>
            <div className="flex justify-between"><span>Your Client's Price:</span><span className="font-bold">{formatCurrency(clientPrice)}</span></div>
            <div className="flex justify-between font-bold text-emerald-700 text-base"><span>Your Margin:</span><span>{formatCurrency(yourMargin)}</span></div>
          </div>
        </div>
      </Card>
      <Card>
        <div className="p-5 space-y-3">
          <Button text="Download Proposal PDF" icon={<Download size={16} />} onClick={onDownloadPdf} fullWidth />
          <Button text="Book a Strategy Call" variant="primary" icon={<BookUser size={16} />} onClick={onBookCall} fullWidth />
        </div>
      </Card>
      <div className="min-h-[400px]">{chatHost}</div>
    </div>
  );
};